import "./index.scss";
import * as actions from "./../../../modules/user/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CITY_BOOKING, GOURMET } from "../../../constants/app";
import DefaultContainer from "./containers/index";
import GourmetContainer from "./containers/gourmet";

const Content = (props) => {
  const { shopDetail } = props.user;
  const isGourmet = shopDetail.category_type === GOURMET;
  const isCityBooking = shopDetail.city_name === CITY_BOOKING;

  if (isCityBooking && isGourmet) {
    return <GourmetContainer {...props} />;
  }
  return <DefaultContainer {...props} />;
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
